// https://gist.github.com/iwazaru/4c8819420ce5237aeaf338339df25c32

function smoothScrollTo(endX, endY, duration) {
  const startX = window.scrollX || window.pageXOffset
  const startY = window.scrollY || window.pageYOffset
  const distanceX = endX - startX
  const distanceY = endY - startY
  const startTime = new Date().getTime()

  const newDuration = typeof duration !== 'undefined' ? duration : 400

  // Easing function
  function easeInOutQuart(time, from, distance, inOutDuration) {
    let scopedTime = time
    scopedTime /= inOutDuration / 2
    if (scopedTime < 1) {
      // eslint-disable-next-line no-mixed-operators
      return (distance / 2) * (scopedTime * scopedTime * scopedTime * scopedTime) + from
    }
    scopedTime -= 2
    // eslint-disable-next-line no-mixed-operators
    return (-distance / 2) * (scopedTime * scopedTime * scopedTime * scopedTime - 2) + from
  }

  const timer = window.setInterval(() => {
    const time = new Date().getTime() - startTime
    const newX = easeInOutQuart(time, startX, distanceX, newDuration)
    const newY = easeInOutQuart(time, startY, distanceY, newDuration)
    if (time >= newDuration) {
      window.clearInterval(timer)
    }
    window.scrollTo(newX, newY)
  }, 1000 / 60) // 60 fps
}

window.smoothScrollTo = smoothScrollTo



// WEBPACK FOOTER //
// ./utilities/scrollToPosition.js